<script>
export default {
  props: {
    orgs: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      searchText: '',
      searchInput: null,
      searchedColumn: '',
      columns: [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'descend',
          sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
          title: 'Address',
          dataIndex: 'address',
          key: 'address',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'descend',
          sorter: (a, b) => a.address.localeCompare(b.address),
        },
        {
          title: 'License',
          dataIndex: 'license',
          key: 'license',
          scopedSlots: {
            customRender: 'customRender',
          },
          defaultSortOrder: 'descend',
          sorter: (a, b) => a.license.localeCompare(b.license),
        },
        {
          title: 'Actions',
          key: 'actions',
          scopedSlots: {
            customRender: 'customRender',
          },
        },
      ],
    }
  },
  methods: {
    selectRow(record) {
      const orgId = record.pk.replace('ORG#', '')
      this.$router.push({
        name: 'organization-profile',
        params: { orgId },
      })
    },
    onDelete(record) {
      this.$emit('deleteOrganization', record)
    },
  },
}
</script>

<template>
  <a-table :data-source="orgs" :columns="columns">
    <template slot="customRender" slot-scope="text, record, index, column">
      <template>
        <div v-if="column.key === 'name'">
          <a @click="() => selectRow(record, column)">{{ text }}</a>
        </div>
        <div v-else-if="column.key === 'license'">
          <a-tag
            :color="text.toLowerCase() === 'enterprise' ? 'purple' : 'blue'"
          >
            {{ text.toUpperCase() }}
          </a-tag>
        </div>
        <div v-else-if="column.key === 'actions'">
          <ul class="actions">
            <li>
              <a
                href="javascript:;"
                title="Edit Organization"
                @click="() => selectRow(record, column)"
                ><a-button type="primary" icon="edit" size="small"></a-button
              ></a>
            </li>
            <li>
              <a-popconfirm
                title="Sure to delete?"
                @confirm="() => onDelete(record)"
              >
                <a href="javascript:;" title="Edit Organization"
                  ><a-button type="danger" icon="delete" size="small"></a-button
                ></a>
              </a-popconfirm>
            </li>
          </ul>
        </div>
        <div v-else>{{ text }}</div>
      </template>
    </template>
  </a-table>
</template>

<style scoped>
.highlight {
  padding: 0;
  background-color: rgb(255, 192, 105);
}
</style>
